const AXIOS_API_CALL = {
  // ROLES
  getRole: 'get-role',
  getRoles: 'get-roles',
  createRole: 'create-role',
  updateRole: 'update-role',
  deleteRole: 'delete-role',
  bulkDeleteRole: 'bulk-delete-role',

  // CUSTOMERS
  getCustomers: 'dashboard/customers',
  deleteCustomers: 'dashboard/customers/delete-account',
  updateCustomers: 'dashboard/customers/edit-customer',
  bulkUpdateStatus: 'dashboard/bulk-deactivate-customer',
  createCustomer: 'dashboard/customers/create-customer',

  // EMPLOYEES
  usersEmployees: 'users/employees',
  usersGetEmoloyee: 'users/get-employee',
  createEmployee: 'create-employee',
  usersUpdateEmoloyee: 'users/update-employee',
  usersBulkDeactivateEmployee: 'users/bulk-deactivate-employee',
  usersDeleteEmployee: 'users/delete-employee',

  // GALLERY
  galleryImages: 'images',
  galleryImagesSearch: 'images?searchTerm=',
  galleryUploadLocalImage: 'upload-local-image',
  updateGalleryImage: 'images-update',
  deleteGalleryImage: 'images-delete',
  uploadLocalImage: 'upload-local-image',
  getImagesById: 'images',

  productGalleryImages: 'product-gallery-images',

  // ADDRESSES - CUSTOMERS
  createDashboardAddresses: 'dashboard/addresses/create-address',
  deleteDashboardAddresses: 'dashboard/addresses/delete-address',

  // PRODUCTS
  getProduct: 'get-product-data',
  getProducts: 'products',
  deleteProduct: 'delete-product',
  deleteProductBulk: 'bulk-delete-product',
  updateProduct: 'update-product',

  // IMPORT FROM NETSUITE
  importProductFromNetSuite: 'import-product-from-netsuite',
  importCategoriesFromNetSuite: 'get-netsuite-categories',

  // ORDERS
  orders: 'orders',
  updateOrder: 'update-order',
  orderDetails: 'order-details',

  // NEW ORDERS
  newOrders: 'new-orders',
  updateNewOrder: 'update-order',
  orderDetailsNew: 'order-details',

  // EMPLOYEE E-MAIL VERIFICATION
  employeeEmailVerification: 'employee-email-verification',

  // ACTIVITY LOG
  logs: 'logs',
  logsDownload: 'logs/download',
  logsCreateFile: 'logs/create-file',

  // CATEGORIES
  categories: 'categories',
  categoriesGetAll: 'categories-get-all',
  checkCategorySlug: 'check-category-slug',
  checkCategoryName: 'check-category-name',

  // ATTRIBUTES
  attributes: 'attributes',
  createAttribute: 'create-attribute',

  // Search
  search: 'searchLog',
  searchByUser: 'searchLog-by-user',

  // UNITS
  units: 'units',
  addUnitToAttribute: 'add-unit-to-attribute',

  // LOGIN
  login: 'login',

  // FORGOT PASSWORD
  forgotPassword: 'forgot-password',

  // PASSWORD RESET
  passwordReset: 'password-reset',

  // PROFILE
  updateEmployee: 'users/update-employee',

  // USERS
  usersGetEmployee: 'users/get-employee',
  employeeLogs: 'employee/logs',

  // PERMISSIONS
  getPermissions: 'get-permissions',

  // USER CHECK TOKEN
  userCheckToken: 'users/check-token',

  // GROCERY
  grocery: 'grocery',
  departmentGrocery: 'grocery',

  // VARIATIONS
  deleteVariation: 'delete-variation'
};

export { AXIOS_API_CALL };
